import React, { useState } from "react"
import { useQuery } from "react-apollo"
import AsyncSelect from "react-select/async"
import { getImportTypeDefinition } from "utils/dataImportType"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Label,
  Button,
  CardBody,
  FormGroup,
  CardHeader,
  CardFooter,
  Alert
} from "reactstrap"
import { GET_PRICEBOOKS, DELETE_PRICEBOOK, SUM_PRICEBOOKS, GET_COMPANIES } from "../gql"
import { CustomServerSideReactTable } from "../../../components/utility"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const PricebookListContainer = (props) => {
  useBread({ to: props.match.url, name: "價目表清單" }, true)

  const [companyId, setCompanyId] = useState('')

  const { data: companiesData, refetch: _getCompanies } = useQuery(GET_COMPANIES, {
    fetchPolicy: "network-only",
    variables: { take: 0 }
  })

  const fieldsDefinition = () => {
    return [
      {
        id: "price",
        Header: "價格",
        width: 100,
        style: columStyle,
        accessor: "price"
      },
      {
        id: "company",
        Header: "公司",
        style: columStyle,
        accessor: "company",
        Cell: (cell) => <div>{cell.row.company.name}</div>
      },
      {
        id: "product",
        Header: "產品",
        style: columStyle,
        accessor: "product",
        Cell: (cell) => <div>{cell.row.product.name}</div>
      }
    ]
  }

  console.log('--companyId--', companyId)

  return (
    <>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label for="companyName">公司名稱</Label>
            <AsyncSelect
                type="select"
                name="companyName"
                id="companyName"
                width="90%"
                placeholder="請選擇公司名稱"
                value={companiesData?.companies?.data
                  .filter((company) => company.id === companyId)
                  .map((o) => ({
                    label: o.name,
                    value: o.id
                  })) || [{}]}
                defaultOptions={companiesData?.companies?.data
                  .map((company) => ({
                    label: company.name,
                    value: company.id
                  })) || [{}]}
                onChange={(e) => {
                  setCompanyId(e.value)
                }}
              >
            </AsyncSelect>
            <Button
              onClick={() => setCompanyId('')}
              className="mt-2"
            >
              清除
            </Button>
          </FormGroup>
        </Col>
      </Row>
       <CustomServerSideReactTable
        queryObjectGql={GET_PRICEBOOKS}
        sumTotalQueryObjectGql={SUM_PRICEBOOKS}
        objectName="價目表"
        objectRoute={props.match.url}
        queryInput={companyId ? { companyId } : null}
        fieldsDef={fieldsDefinition()}
      />
    </>
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(PricebookListContainer)
